import { APP_NAME, IS_PROD } from '../../lib/config'

const ENV_SUFFIX = IS_PROD ? '-prod' : '-test'

export const MAP_STYLE_KEY = `mezzoforte:${APP_NAME}:mapstyle${ENV_SUFFIX}-v1`
export const MAP_3D_KEY = `mezzoforte:${APP_NAME}:3dmap${ENV_SUFFIX}`
export const MAP_STYLE_DEFAULT = 'vector'

export const AGAMI_VIZ_MODE_KEY = `mezzoforte:${APP_NAME}:agamivizmode${ENV_SUFFIX}`
export const AGAMI_VIZ_MODE_DEFAULT = 'cards'

export const EXP_SETTINGS_SIDEBAR_KEY = `mezzoforte:${APP_NAME}:expsettingssidebar${ENV_SUFFIX}`

export const SHARED_EXPERIENCES_SECTION_KEY = `mezzoforte:${APP_NAME}:sharedexperiences${ENV_SUFFIX}`

export const FONT_SIZE_KEY = `mezzoforte:${APP_NAME}:fontsize${ENV_SUFFIX}`
export const FONT_SIZE_DEFAULT = 16

export const THEME_KEY = `mezzoforte:${APP_NAME}:theme${ENV_SUFFIX}`
